<!-- 论文要求查看 -->
<template>
    <div class="el-Require">
        <el-row class="page_content">
            <h1 class="head_title">{{$getShowName()}}要求查看</h1>
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column prop="title" header-align="center" align="center" label="标题">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="附件名称">
                    <template slot-scope="scope">
                        <a @click="getFile(scope.row.fileUrl)" style="color:#1890ff;cursor:pointer">{{ scope.row.fileName }}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="professionalName" header-align="center" align="center" label="专业名称">
                </el-table-column>
                <el-table-column prop="operateTime" header-align="center" align="center" label="创建时间">
                </el-table-column>
                <el-table-column prop="batchName" header-align="center" align="center" label="批次">
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 10px;" background :page-size="limit" layout="prev, pager, next" :total="page"
                @current-change="pageChange">
            </el-pagination>
        </el-row>

    </div>
</template>
<script>
export default {
    name: "ask",
    data() {
        return {
            page: 1,
            limit: 10,
            tableData: [
            ],
            dialogImageUrl: '',
            dialogVisible: false
        };
    },
    created() {

    },
    mounted() {
      
        this.getTable()
    },
    methods: {
        getTable() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let param = {
                limit: this.limit,
                page: this.page
            }
            this.$store.dispatch("thesis/getThesisRequestListByStudent", param).then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.tableData = ret.data
                    this.page = ret.count

                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        handleCurrentChange(val) {
            this.page = val
            this.getTable();
        },
        //下载
        getFile(url, name) {
            const a = document.createElement("a");
            const prefix = window.configs.API_ROOT;
            let setturl=prefix+url
            fetch(setturl)

                .then((res) => res.blob())

                .then((blob) => {

                    // 将链接地址字符内容转变成blob地址

                    a.href = URL.createObjectURL(blob);

                    a.download = name; // 下载文件的名字

                    // a.download = url.split('/')[url.split('/').length -1] //  // 下载文件的名字

                    document.body.appendChild(a);

                    a.click();

                    document.body.removeChild(a);

                })

        }
    }
};
</script>
<style  lang="less">
@import '../../styles/base.less';

.el-Require {
    .wd {
        color: @red;
    }

    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
}
</style>


// WEBPACK FOOTER //
// src/pages/transactionPaper/ask.vue